import Event from 'Faster/model/Event';
import EventService from 'Faster/service/EventService';

class FasterEvent {
  private eventService: EventService;

  public constructor(eventService: EventService) {
    this.eventService = eventService;
  }

  public register(event: Event): void {
    try {
      this.eventService.sendEvent(event);
    } catch (e) {
      console.warn('Error when sending event:', e);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public registerWithPromise(event: Event, exposeErrors = false): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.eventService.sendEventWithPromise(event).catch((error: any) => {
      console.warn('Error when sending event:', error);

      if (exposeErrors) {
        throw error;
      }
    });
  }
}

export default FasterEvent;
